export const AdjustTokens = {
  aviaSearch: 'fws4l0',
  aviaBooking: 'rck0qv',
  aviaPurchase: 'l25dr5',
} as const

export type AdjustEvent = keyof typeof AdjustTokens
